import React, { useEffect, useRef, useState } from "react";
import * as ReactBootstrap from "react-bootstrap";
import searchicon from "../../../assets/icons/searchIcon.svg";
import addIcon from "../../../assets/icons/add-circle.svg";
import PaginationComponent from "../../../utilities/Pagination";
import "./AffiliateTable.scss";
import { useSelector } from "react-redux";
import axios from "axios";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { Empty, Modal, Spin, Tooltip } from "antd";
import CodeIcon from "../../../assets/Affiliate/codeIcon.svg";
import RevenueIcon from "../../../assets/Affiliate/revenueIcon.svg";
import JoinedIcon from "../../../assets/Affiliate/joined.svg";
import { FormatUSD } from "../../../utilities/string";
import * as echarts from "echarts";
import { useNavigate } from "react-router";
import moment from "moment";
import Loader from "../../../reusableComponents/Loader";
import { formatDate } from "../../../utilities/formatters";
import activeIcon from "../../../assets/icons/activeIcon.svg";
import CrossIcon from "../../../assets/icons/CrossIcon.svg";
import ReactTable from "../../../components/ReactTable/ReactTable";

function AffiliateTable() {
  const [paramsValue, setParamsValue] = useState({
    page: 1,
    page_size: 10,
  });
  const { paginated_affiliates } = useSelector((state) => state.affiliate);
  const [pageSize, setPageSize] = useState(10);
  const [affiliateList, setAffiliateList] = useState({ results: [], count: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Use Redux data if available, otherwise fetch
  useEffect(() => {
    if (paginated_affiliates?.results?.length) {
      setAffiliateList(paginated_affiliates);
    } else {
      fetchAffiliate();
    }
  }, [paginated_affiliates, paramsValue, pageSize]);

  // Calculate pagination values
  const totalItems = affiliateList?.count || 0;
  const totalPages = Math.ceil(totalItems / pageSize);

  // Search debounce
  let searchTimeout;
  const handleSearchChange = (e) => {
    const value = e.target.value;
    if (searchTimeout) clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      setParamsValue((prev) => ({ ...prev, search: value, page: 1 }));
    }, 300);
  };

  // Cleanup search timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeout) clearTimeout(searchTimeout);
    };
  }, []);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setParamsValue((prev) => ({ ...prev, page }));
    }
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setParamsValue((prev) => ({ ...prev, page: 1, page_size: newPageSize }));
  };
  const { ACCtoken } = useSelector((state) => state);

  const fetchAffiliate = async () => {
    setLoading(true);
    setError(null);

    try {
      const config = {
        headers: {
          Authorization: ACCtoken,
        },
        params: paramsValue,
      };
      const response = await axios.get(`/affiliate/v2/code/list`, config);
      setAffiliateList(response.data || { results: [], count: 0 });
    } catch (error) {
      console.error("Error fetching affiliates:", error);
      setError(
        error.response?.data?.message || "Failed to fetch affiliate list."
      );
      setAffiliateList({ results: [], count: 0 });
    } finally {
      setLoading(false);
    }
  };

  const handleCopyToClipboard = (text) => {
    if (text) {
      toast("Affiliate link copied.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "success",
        theme: "dark",
        className: "custom-toast-container",
      });
    }
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalValues, setModalValues] = useState(null);
  const [params, setParams] = useState({
    page: 1,
    page_size: 10, // Smaller default for modal
  });

  const fetchAffiliateRefer = async () => {
    setLoading(true);
    try {
      const config = {
        headers: {
          Authorization: ACCtoken,
        },
        params: params,
      };

      const [response, countrystats] = await Promise.all([
        axios.get(`affiliate/get/code/referred-users/list/`, config),
        axios.get(`affiliate/get/countrywise-code/list/`, config),
      ]);

      setModalValues({
        details: response?.data?.results || [],
        count: response?.data?.count || 0,
        ...countrystats?.data,
      });
    } catch (error) {
      console.error("Error fetching affiliates:", error);
      setModalValues({ details: [], count: 0 });
      setError("Failed to fetch affiliate details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (params?.affiliate_code_id) {
      setIsModalOpen(true);
      fetchAffiliateRefer();
    }
  }, [params]);

  const navigate = useNavigate();

  return (
    <div
      className="LeaderboardPage PaymentHistoryPage affiliateTable"
      style={{ position: "relative", width: "100%" }}
    >
      {" "}
      {<Loader open={loading} />}
      <div className="HistoryDesk">
        <div className="table_header">
          <div className="table_header_left">
            <div className="search_bar_wrapper">
              <img src={searchicon} alt="search icon" />
              <input
                type="text"
                className="search_input"
                placeholder="Search..."
                onChange={handleSearchChange}
                style={{ borderRadius: "0px" }}
              />
            </div>
          </div>
          <div
            onClick={() => navigate("/affiliateMarketing/create-affiliate")}
            style={{ cursor: "pointer" }}
            className="create_btn"
          >
            {/* <img src={addIcon} alt="add icon" />
            <p>Create Affiliate Code</p> */}
          </div>
        </div>

        {!affiliateList?.results?.length ? (
          <div className="no-data">
            <Empty />
          </div>
        ) : (
          <>
            <div className="affiliateTableContainer">
              <ReactTable
                columns={[
                  {
                    Header: "Status",
                    accessor: "coupon_is_active",
                    width: 180,
                    Cell: ({ row }) => (
                      <div
                        className={`status_div ${
                          row.original.coupon_is_active
                            ? "StatusPassed"
                            : "StatusFailed"
                        }`}
                      >
                        {row.original.coupon_is_active ? (
                          <img src={activeIcon} alt="active" />
                        ) : (
                          <img src={CrossIcon} alt="inactive" />
                        )}
                        {row.original.coupon_is_active
                          ? "Active"
                          : "Deactivated"}
                      </div>
                    ),
                  },
                  {
                    Header: "Date",
                    accessor: "created",
                    width: 200,
                    Cell: ({ value }) =>
                      value
                        ? moment(value).format("DD-MMM-YYYY HH:mm:ss")
                        : "NA",
                  },
                  {
                    Header: "Commission %",
                    accessor: "percentage",
                    width: 150,
                    Cell: ({ value }) => (value ? `${value}%` : "N/A"),
                  },
                  {
                    Header: "% (Repeat)",
                    accessor: "repeat_percent",
                    width: 150,
                    Cell: ({ value }) =>
                      value !== null && value !== undefined
                        ? `${value}%`
                        : "N/A",
                  },
                  {
                    Header: "Code",
                    accessor: "code",
                    width: 200,
                    Cell: ({ value }) => (
                      <>
                        {value}
                        <CopyToClipboard
                          onCopy={() => handleCopyToClipboard(value)}
                          text={value}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="copy_icon"
                            style={{ cursor: "pointer", marginLeft: "8px" }}
                          >
                            <path
                              d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z"
                              fill="#B0B0B0"
                            />
                          </svg>
                        </CopyToClipboard>
                      </>
                    ),
                  },
                  {
                    Header: "URL",
                    accessor: "url",
                    width: 250,
                    Cell: ({ value }) => (
                      <div className="aff_code_url">
                        <a
                          href={value}
                          target="_blank"
                          rel="noopener noreferrer"
                          title={value}
                          style={{ color: "#F6F6F6", fontWeight: "500" }}
                        >
                          {value && value.length > 20
                            ? `${value.substring(0, 20)}...`
                            : value}
                        </a>
                        <CopyToClipboard
                          onCopy={() => handleCopyToClipboard(value)}
                          text={value}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="copy_icon"
                            style={{ cursor: "pointer", marginLeft: "8px" }}
                          >
                            <path
                              d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z"
                              fill="#B0B0B0"
                            />
                          </svg>
                        </CopyToClipboard>
                      </div>
                    ),
                  },
                  {
                    Header: "Pushed Leads",
                    accessor: "pushed_leads",
                    width: 150,
                    Cell: ({ value }) => value || 0,
                  },
                  {
                    Header: "Conversion",
                    accessor: "conversion",
                    width: 150,
                    Cell: ({ value }) => value || 0,
                  },
                  {
                    Header: "Referred List",
                    accessor: "coupon_id",
                    width: 150,
                    Cell: ({ row }) => (
                      <div
                        className="view-details-btn"
                        onClick={() => {
                          setParams((prev) => ({
                            ...prev,
                            affiliate_code_id: row.original.coupon_id,
                            page: 1, // Reset page when opening modal
                          }));
                        }}
                      >
                        View Details
                      </div>
                    ),
                  },
                ]}
                data={affiliateList.results}
                manualPagination={true}
                page={paramsValue.page}
                pageSize={pageSize}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                totalCount={totalItems}
              />
            </div>

            <ModalCard
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              modalValues={modalValues}
              loading={loading}
              params={params}
              setParams={setParams}
            />
          </>
        )}
      </div>
    </div>
  );
}

const ModalCard = ({
  isModalOpen,
  setIsModalOpen,
  modalValues,
  loading,
  params,
  setParams,
}) => {
  // Helper function to format USD
  const FormatUSD = (value) => {
    if (typeof value === "string" && value.startsWith("$")) {
      return value;
    }
    return `$${Number(value || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  // Calculate pagination values for modal table
  const totalItems = modalValues?.count || 0;
  const totalPages = Math.ceil(totalItems / params.page_size);

  // Handle page change for modal table
  const handleModalPageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setParams((prev) => ({ ...prev, page }));
    }
  };

  // Handle page size change for modal table
  const handleModalPageSizeChange = (newPageSize) => {
    setParams((prev) => ({ ...prev, page: 1, page_size: newPageSize }));
  };

  // Transform countries array to object for PieChart compatibility
  const countriesForChart = modalValues?.countries?.reduce((acc, country) => {
    acc[country.Country] = {
      totalJoined: country.new_joinee,
      totalRevenue: FormatUSD(country.revenue),
    };
    return acc;
  }, {});

  // Get primary country for initial display (highest join count)
  const primaryCountry = modalValues?.countries?.reduce(
    (max, country) =>
      country.new_joinee > (max?.new_joinee || 0) ? country : max,
    modalValues?.countries?.[0] // Fallback to first country if no max
  );

  const [selectedCountry, setSelectedCountry] = useState(
    primaryCountry?.Country || ""
  );

  // Update selected country when modal values change
  useEffect(() => {
    setSelectedCountry(primaryCountry?.Country || "");
  }, [modalValues]);

  // Get stats for selected country
  const selectedCountryStats = modalValues?.countries?.find(
    (country) => country.Country === selectedCountry
  );

  return (
    <Modal
      title="Code Details"
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      className="refer-details-modal"
    >
      <Spin spinning={loading}>
        <div className="stats">
          <div className="stats-box">
            <div className="img">
              <img src={CodeIcon} alt="Code" /> <p>Code</p>
            </div>
            <Tooltip
              style={{ overflow: "auto", color: "#fff" }}
              title={
                modalValues?.code_name && modalValues?.code_name.length >= 7
                  ? modalValues?.code_name
                  : undefined
              }
            >
              {modalValues?.code_name.length > 7
                ? modalValues?.code_name.slice(0, 7) + "..."
                : modalValues?.code_name || "N/A"}
            </Tooltip>
          </div>
          <div className="stats-box">
            <div className="img">
              <img src={RevenueIcon} alt="Revenue" /> <p>Total Revenue</p>
            </div>
            <p>{FormatUSD(modalValues?.total_revenue)}</p>
          </div>
          <div className="stats-box">
            <div className="img">
              <img src={JoinedIcon} alt="Joined" /> <p>Total Joined</p>
            </div>
            <p>{modalValues?.total_joinee || 0}</p>
          </div>
        </div>
        <div className="graph-and-table">
          <div className="country-graph">
            <p>Countries - Code used in</p>
            <div className="chart">
              <div className="country-name">
                {selectedCountry?.replace(
                  "United Kingdom of Great Britain and Northern Ireland",
                  "Northern Ireland"
                ) || "N/A"}
              </div>
              <div className="country-stats">
                <div>
                  <p>Total joined</p>
                  <p>{selectedCountryStats?.new_joinee || 0}</p>
                </div>
                <div>
                  <p>Total Revenue</p>
                  <p>{FormatUSD(selectedCountryStats?.revenue)}</p>
                </div>
              </div>
              <PieChart
                data={countriesForChart || {}}
                setSelectedCountry={setSelectedCountry}
                selectedCountry={selectedCountry}
              />
            </div>
          </div>
          <div className="refer-table">
            <p>Details</p>
            <div className="table-wrapper">
              <ReactBootstrap.Table className="referTable">
                <thead>
                  <tr>
                    <th style={{ paddingLeft: "20px" }}>First Name</th>
                    <th style={{ paddingLeft: "20px" }}>Last Name</th>
                    <th>Country</th>
                    <th>Date</th>
                    <th>Account Size</th>
                    <th>Account Price</th>
                    <th>Commission Earned</th>
                  </tr>
                </thead>
                <tbody>
                  {!modalValues?.details?.length ? (
                    <tr>
                      <td colSpan={6} className="no-data">
                        <div className="empty-container">
                          <Empty
                            color="#B0B0B0"
                            description="No referral data available"
                          />
                        </div>
                      </td>
                    </tr>
                  ) : (
                    modalValues?.details.map((data, index) => (
                      <tr key={data.id || index}>
                        <td style={{ paddingLeft: "20px" }}>
                          {data?.name
                            ? data?.name.split(" ")[0]
                            : data?.first_name || "N/A"}
                        </td>
                        <td style={{ paddingLeft: "20px" }}>
                          {data?.name
                            ? data?.name.split(" ").slice(1).join(" ") || "N/A"
                            : data?.last_name || "N/A"}
                        </td>
                        <td style={{ width: "150px" }}>
                          {data.Country?.replace(
                            "United Kingdom of Great Britain and Northern Ireland",
                            "Northern Ireland"
                          ) || "N/A"}
                        </td>
                        <td style={{ width: "150px" }}>
                          {data.date_joined
                            ? moment(data.date_joined).format("DD-MMM-YYYY")
                            : "N/A"}
                        </td>
                        <td style={{ width: "150px" }}>
                          {data.account_size || "N/A"}
                        </td>
                        <td style={{ width: "150px" }}>
                          {FormatUSD(data.account_price)}
                        </td>
                        <td style={{ width: "150px" }}>
                          {FormatUSD(data.commission)}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </ReactBootstrap.Table>
            </div>
            {totalPages > 0 && (
              <PaginationComponent
                currentPage={params?.page || 1}
                totalPages={totalPages}
                onPageChange={handleModalPageChange}
                pageSize={params?.page_size || 10}
                setPageSize={handleModalPageSizeChange}
              />
            )}
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

const PieChart = ({ data, selectedCountry, setSelectedCountry }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      const myChart = echarts.init(chartRef.current);
      const chartData = Object.entries(data)
        .map(([country, stats]) => ({
          value: stats.totalJoined,
          name: country,
        }))
        .sort((a, b) => b.value - a.value); // Sort by value for better visualization

      const option = {
        tooltip: {
          position: "top",
          trigger: "item",
          formatter: (params) => {
            const { name, value } = params;
            const total = chartData.reduce((sum, item) => sum + item.value, 0);
            return `<div style=\"max-width:200px;white-space:normal;word-break:break-word;\">${name}: ${value} joined (${(
              (value / total) *
              100
            ).toFixed(1)}%)</div>`;
          },
        },
        legend: {
          type: "scroll", // Enable scrollable legend
          right: 10, // Position legend on the right
          top: "bottom", // Center vertically
          height: "80%", // Limit legend height to fit within chart
          itemHeight: 12, // Smaller item height for compact display
          itemWidth: 12, // Smaller item width
          itemGap: 8, // Reduced gap between legend items
          textStyle: {
            color: "#FFFFFF",
            fontSize: 12, // Smaller font size for readability
          },
          pageButtonPosition: "end", // Scroll buttons at the bottom
          pageTextStyle: {
            color: "#FFFFFF", // Style for pagination text
          },
          selected: {
            [selectedCountry]: true, // Highlight selected country
          },
        },
        series: [
          {
            name: "Countries",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
            },
            labelLine: { show: false },
            data: chartData,
            itemStyle: {
              color: (params) => {
                const colors = [
                  "#5470C6",
                  "#91CC75",
                  "#EE6666",
                  "#73C0DE",
                  "#3BA272",
                  "#FC8452",
                  "#9A60B4",
                  "#EA7CCC",
                  "#FAC858",
                  "#EE6666",
                  "#73C0DE",
                  "#3BA272",
                ];
                return colors[params.dataIndex % colors.length];
              },
            },
          },
        ],
      };

      myChart.on("mouseover", "series.pie", (params) => {
        setSelectedCountry(params.name);
      });

      myChart.setOption(option);
    }
  }, [data, selectedCountry, setSelectedCountry]);

  return (
    <div ref={chartRef} id="main" style={{ width: "100%", height: "300px" }} />
  );
};

export default AffiliateTable;
